// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"cluster_tooltip__YkdSE"};